import { useState } from 'react';
import { Modal, ModalControlProps } from '../../../layouts/Modal';
import { Button } from '../../base/Button';
import { LoadingWheel } from '../../base/LoadingWheel';
import useOrganisationTokenMutations from '../../../data/organisation/useOrganisationTokenMutations';
import useOrganisation from '../../../data/organisation/useOrganisation';
import { Alert } from '../../base/Alert';
import useUser from '../../../data/user/useUser';

const melPumpUrl = (email: string, token: string) => `https://melpump.com/special-signup/planet-devices?email=${encodeURIComponent(email)}&api_token=${encodeURIComponent(token)}`;

interface MELPumpModalProps extends ModalControlProps { }

export function MELPumpModal({ open, onClose }: MELPumpModalProps) {
  const { create } = useOrganisationTokenMutations();
  const { user } = useUser();
  const { organisation } = useOrganisation();
  const [generatedToken, setGeneratedToken] = useState<string>();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const createToken = (onSuccess: (token: string) => void) => {
    create.mutate(
      {
        tokenName: '__SYSTEM_MELPump',
        roleId: organisation.data?.adminRole!,
      },
      {
        onSuccess: (response) => {
          if (response.data?.data?.length > 0 && response.data.data[0].key) {
            setGeneratedToken(response.data.data[0].key);
            onSuccess(response.data.data[0].key);
          } else {
            console.error('No token returned from API');
            setError(true);
          }
        },
        onError: (error) => {
          console.error('Error creating MEL Pump token:', error);
          setError(true);
        },
        onSettled: () => {
          setSubmitting(false);
        },
      }
    );
  };

  const redirectToMelPump = (token: string) => {
    window.open(melPumpUrl(user.data?.email!, token), '_blank');
  }

  const handleConnect = () => {
    setSubmitting(true);
    createToken(redirectToMelPump);
  }

  const handleClose = () => {
    setTimeout(() => {
      setGeneratedToken(undefined);
    }, 200);

    onClose(true);
  }

  return (
    <Modal open={open} onClose={onClose} title="Connect MEL Pump" dialogStatic>
      <p>Optimize your heat pump settings and save money effortlessly with MEL Pump's cutting-edge heat pump monitoring app</p>
      <div className="my-10 flex items-center justify-center">
        {error ? (
          <Alert severity='error' message='Unexpected error occurred. Please try again, if the issue persists, please contact support.' />
        ) :
          submitting || organisation.isLoading ? (
            <LoadingWheel />
          ) : !generatedToken ? (
            <Button size="lg" onClick={handleConnect}>
              Connect MEL Pump
            </Button>
          ) : (
            <Alert severity='success' message='Mel Pump connected successfully' />
          )}
      </div>
      <div>
        <Button onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
}
